import WordInsideWriteArea from "@/pages/comp/plan/word/word_inside/common/write";

function WordInsideWritePopup(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    row_data: {},
    is_update: false,
    ...props
  };

  return (
    <div>
      <WordInsideWriteArea
        closePopup={myProps.closePopup}
        refreshData={myProps.refreshData}
        callbackData={myProps.callbackData}
        row_data={myProps.row_data}
        is_update={myProps.is_update}
      ></WordInsideWriteArea>
    </div>
  );
};
export default WordInsideWritePopup;